
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","width":"14","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M402.617 22.138c-22.358 2.844-42.713 14.458-58.65 30.395L107.081 289.419c-10.441 10.441-18.426 23.557-20.823 38.128-7.463 45.373 31.354 84.241 76.754 76.888 14.572-2.36 27.703-10.317 38.141-20.755l216.138-216.138c4.166-4.166 4.166-10.919 0-15.085l-15.082-15.082c-4.166-4.166-10.919-4.166-15.085 0L168.833 355.667c-4.521 4.51-10.531 7-16.938 7-13.177 0-23.896-10.74-23.896-23.938 0-6.375 2.49-12.375 7-16.896l241.99-241.99C387.208 69.625 400.792 64 415.24 64c29.823 0 54.094 24.271 54.094 54.833 0 14.104-5.396 27.458-15.208 37.604L201.889 417.381c-15.268 15.794-35.076 27.287-56.884 29.931-57.832 7.012-106.769-40.495-102.019-99.332 1.801-22.307 12.788-42.92 28.613-58.745l234.61-234.61c4.166-4.166 4.166-10.919 0-15.085l-15.082-15.082c-4.166-4.166-10.919-4.166-15.085 0L39.156 261.344C13.912 286.588.007 320.14 0 356.964c-.006 34.51 14.082 68.053 38.293 92.645 58.148 59.065 143.284 50.156 191.509.287l255-263.813C502.344 167.948 512 144.063 512 118.094c0-57.507-50.426-103.457-109.383-95.956z"}})])
          )
        }
      }
    